/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getDashboardWidgets,
    getDashboardWidget,
    printDashboardWidget,
    createDashboardWidgets,
    updateDashboardWidgets,
    deleteDashboardWidgets,
} from "Core/configuration/dashboard_widgets/config/api.dashboard_widgets";

const state = {
    page: {},
    form: {},
    dashboard_widgets: [],
    dashboard_widget_options: [],
    selectedDashboardWidget: {
        widget_id: null,
        company_id: "",
        dashboard_widget_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        dashboard_widget_details: [],
    },
    dashboard_widgets_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_dashboard_widgets: {
        name: {
            name: "name",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        name_alias: {
            name: "name_alias",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        column_span: {
            name: "column_span",
            rules: "trim|max_length[2]|integer|required",
            max_len: "2",
            min_len: "",
            default_value: "12",
        },
        permission: {
            name: "permission",
            rules: "trim|max_length[18]",
            max_len: "18",
            min_len: "",
            default_value: "",
        },
        active: {
            name: "active",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
    },
};

// getters
const getters = {
    dashboard_widgets: (state) => {
        return state.dashboard_widgets;
    },
};

// actions
const actions = {
    async fetchDashboardWidgets({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getDashboardWidgets({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "dashboard_widget_options",
                        with: response.data.dashboard_widgets,
                    });
                } else {
                    commit("mutate", {
                        property: "dashboard_widgets",
                        with: response.data.dashboard_widgets,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchDashboardWidget({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getDashboardWidget(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedDashboardWidget",
                    with: response.data.dashboard_widget,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printDashboardWidget({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printDashboardWidget(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveDashboardWidget({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["widget_id"] === "undefined" || body["widget_id"] == null || body["widget_id"] == "") {
                delete body["widget_id"];
                response = await createDashboardWidgets({ body: body, headers: config.headers });
            } else {
                let widget_id = body["widget_id"];
                delete body["widget_id"];
                response = await updateDashboardWidgets({ body: body, headers: config.headers }, widget_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteDashboardWidget({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteDashboardWidgets(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
